import React from "react";
import DefaultLayout from "../layouts/Default";
import Image from "../utils/Image";
import TitleCar from "../utils/TitleCar";
import Slider from "../utils/Slider";
import CardHome from "../utils/CardHome";
import "react-tabs/style/react-tabs.css";
import styled from "styled-components";

const images = require.context("../../assets/img/", true);

const InfoPage = [
  {
    title: "Quiénes somos",
    description:
      "Se establece como un sistema de Información que consolida los Programas, Proyectos, Metas y Actividades que comprenden los instrumentos de planificación de largo, mediano y corto plazo, de la Corporación Autónoma Regional CAR ",
    src: images("./TarjetasHome/img1.png"),
    href: "/quienes-somos",
  },
  {
    title: "Marco Legal",
    description:
      "La Constitución Política de Colombia otorga el derecho a todas las personas a gozar de un ambiente sano, imponiendo, además de un régimen de responsabilidad ambiental, el deber al Estado de planificar el manejo y aprovechamiento de los recursos naturales, para garantizar su desarrollo sostenible, su conservación, restauración o sustitución, y de proteger la diversidad e integridad del medio ambiente.",
    src: images("./TarjetasHome/img2.png"),
    href: "/marco-legal",
  },
  {
    title: "Proyectos",
    description:
      "El conjunto de actividades y acciones que requieren la utilización de recursos financieros para satisfacer una necesidad o solucionar un problema de la comunidad.",
    src: images("./TarjetasHome/img3.png"),
    href: "/tipos-proyectos",
  },
  {
    title: "Presente su Proyecto",
    description:
      "Con el fin de establecer procedimientos claros en la radicación de los diferentes tipos de proyectos de Inversión que desarrolla la Corporación a través del Banco de Programas y Proyectos de Inversión BPPI-CAR se establecen una serie de pasos y documentos de referencia para la radicación de la iniciativa.",
    src: images("./TarjetasHome/img4.png"),
    href: "/presente-su-proyecto",
  },
  {
    title: "Instrumentos de planeación",
    description: "En desarrollo...",
    src: images("./TarjetasHome/img5.png"),
    href: "/",
  },
  {
    title: "Formula CAR",
    description:
      "Es una herramienta web que permite el registro de la información en un orden lógico para la formulación y evaluación de un proyecto",
    src: images("./TarjetasHome/img6.png"),
    href: "/formula-car",
  },
];

const Grid3 = styled.div`
  display: grid;
  margin-top: 2rem;
  grid-template-columns: 30% 30% 30%;
  column-gap: 4.5%;
  row-gap: 2rem;
`;
const MainBanner = () => {
  const sliders = [
    { imageURL: "./banner1.png" },
    { imageURL: "./banner1.png" },
  ];

  return (
    <Slider
      data={sliders.map((item, index) => (
        <Image
          key={index}
          src={images(item.imageURL)}
          alt={`Banner #${index + 1} de la pagina web`}
          classNameDiv="p-0"
          classNameImg="w-100"
        ></Image>
      ))}
      id="slider-banner"
      classItems="w-100"
    />
  );
};

const Home = () => {
  const cardViews = InfoPage.map((card) => (
    <CardHome
      title={card.title}
      description={card.description}
      src={card.src}
      href={card.href}
    />
  ));

  return (
    <DefaultLayout>
      <MainBanner />
      <div className="row justify-content-center ">
        <div className="row col-11 col-lg-9 my-4">
          <div className="col-12 py-3">
            <TitleCar>
              <b>Contenidos</b>
            </TitleCar>
          </div>
          <div className="px-5 ">
            <Grid3>{cardViews}</Grid3>
          </div>

          <hr className="my-5" />
        </div>
      </div>
    </DefaultLayout>
  );
};

export default Home;
